import React from 'react';
// import { Close } from '@mui/icons-material';
import { ChipProps } from '@mui/material';
import Chip from '../../../chip/chip';
import Typography from '../../../typography/typography';

interface ChipOrPlaceholderProps {
	data: string[];
	placeholder: string;
	onDelete?: () => void;
	chipProps?: Omit<ChipProps, 'label'>;
	disabled?: boolean;
	selectedLabel?: string;
}

const ChipOrPlaceholder: React.FC<ChipOrPlaceholderProps> = ({
	data,
	placeholder,
	onDelete,
	chipProps,
	disabled,
	selectedLabel = 'Item'
}) => (
	<>
		{data.length ? (
			<Chip
				// variant='outlined'
				type='normal'
				label={
					<Typography color='theme.secondary.1000' type='s5'>
						{data.length} {selectedLabel} Selected
					</Typography>
				}
				// deleteIcon={<Close fontSize='large' />}
				onDelete={onDelete}
				onMouseDown={(event) => event.stopPropagation()}
				disabled={Boolean(disabled)}
				{...chipProps}
				sx={{
					...chipProps?.sx,
					'& .MuiChip-deleteIcon': {
						color: 'theme.primary.800',
						fontSize: '1rem',
						'&:hover': {
							color: 'theme.primary.900'
						}
					}
				}}
			/>
		) : (
			<Typography color='inherit' type='s3'>
				{placeholder}
			</Typography>
		)}
	</>
);

export default ChipOrPlaceholder;
